export default __webpack_public_path__ + "static/media/2.e0a5db0b.jpg";